function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M-1-1h582v402H-1z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M485 70.06c-253 0-401-7-401 126 0 201 160 153 401 153s401 48 401-153c0-133-148-126-401-126z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485 269.06c-237 0-378-107-378 103 0 59 46 70 175 70 69 0 111 7 203 7s134-7 203-7c129 0 175-11 175-70 0-210-141-103-378-103z"
}));

var SvgSpeechBubble = function SvgSpeechBubble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 970 531.06",
    preserveAspectRatio: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeechBubble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speech-bubble.5d514ae8.svg";
export { ForwardRef as ReactComponent };